import { logFeatureEvent } from "./shared";

type OnboardingScriptState = "not_installed" | "not_in_head";

type ReportOnboardingScriptNotDetectedParams = {
  domain: string;
  scriptId: string;
  scriptInstalled?: boolean;
  scriptInstalledHead?: boolean;
  alternativeUrl?: string;
};

const getOnboardingScriptState = (
  scriptInstalled?: boolean,
  scriptInstalledHead?: boolean,
): OnboardingScriptState | null => {
  if (scriptInstalled === false) return "not_installed";
  if (scriptInstalled === true && scriptInstalledHead === false) return "not_in_head";
  if (scriptInstalledHead === false) return "not_in_head";
  return null;
};

export const reportOnboardingScriptNotDetected = ({
  domain,
  scriptId,
  scriptInstalled,
  scriptInstalledHead,
  alternativeUrl,
}: ReportOnboardingScriptNotDetectedParams) => {
  const scriptState = getOnboardingScriptState(scriptInstalled, scriptInstalledHead);
  if (!scriptState) return;

  const scriptKey = scriptId || "unknown-script";

  logFeatureEvent({
    feature: "onboarding",
    event: "script_not_detected",
    level: "warn",
    message: "Onboarding: tracking script not detected",
    scope: { domain },
    dedupKey: `script-not-detected:${scriptKey}:${scriptState}`,
    attributes: {
      script_id: scriptKey,
      script_state: scriptState,
      script_installed: scriptInstalled ?? null,
      script_installed_head: scriptInstalledHead ?? null,
      alternative_url: alternativeUrl ?? null,
    },
  });
};
